import React from 'react'
import ArdLogo from 'assets/home/ard-logo-dark.svg'
import DeutscheStartupsLogo from 'assets/home/deutsche-startup-logo-dark.svg'
import HandelsblattLogo from 'assets/home/handelsblatt-logo-dark.svg'
import WirtschaftsWocheLogo from 'assets/home/wirtschaftswoche-logo-dark.svg'
import OrangeLogo from 'assets/home/orange-logo-dark.svg'
import ArdWhiteLogo from 'assets/for-parents/ARD_logo.svg'
import DeutscheStartupsWhiteLogo from 'assets/for-parents/DEstartup_logo.svg'
import HandelsblattWhiteLogo from 'assets/for-parents/Handelsblatt_logo.svg'
import WirtschaftsWocheWhiteLogo from 'assets/for-parents/Wirtschaftswoche_logo.svg'
import OrangeWhiteLogo from 'assets/for-parents/Orange_logo.svg'
import styled, { css } from 'styled-components'
import { Body2 } from 'stories/elements/Typography/Text'
import theme from 'stories/utils/theme'

const Container = styled.div<{ backgroundColor?: string; background?: string }>`
    background-color: ${({ backgroundColor }) => backgroundColor ?? theme.colors.darkerAccentBlue};
    ${({ background }) =>
        background
            ? css`
                background: ${background}
                background-blend-mode: lighten;
                opacity: 0.8;
            `
            : 'none'};
    padding: 15px;
`

const Grid = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: center;
    grid-gap: 50px;
    padding: 15px 0;
    min-height: 90px;
    @media (max-width: 750px) {
        flex-wrap: wrap;
        justify-content: center;
    }
`

interface Props {
    hideTitle?: boolean
    backgroundColor?: string
    background?: string
    showWhiteLogos?: boolean
}

const DarkReferences = ({ hideTitle, backgroundColor, showWhiteLogos, background }: Props) => (
    <Container backgroundColor={backgroundColor} background={background}>
        {!hideTitle ? (
            <Body2 color={showWhiteLogos ? theme.colors.white : theme.colors.body2Black} textAlign="center">
                Bekannt durch
            </Body2>
        ) : null}
        <Grid>
            {showWhiteLogos ? <ArdWhiteLogo /> : <ArdLogo />}
            {showWhiteLogos ? <DeutscheStartupsWhiteLogo /> : <DeutscheStartupsLogo />}
            {showWhiteLogos ? <WirtschaftsWocheWhiteLogo /> : <WirtschaftsWocheLogo />}
            {showWhiteLogos ? <OrangeWhiteLogo /> : <OrangeLogo />}
            {showWhiteLogos ? <HandelsblattWhiteLogo /> : <HandelsblattLogo />}
        </Grid>
    </Container>
)

export default DarkReferences
